<template>
    <div class="video_h5R">
       <aliPlayer :source="endVideo" @videoEnd='videoOver'></aliPlayer>   
    </div>
</template>
<script>
import aliPlayer from "components/aliPlayerHeadTail"

export default {
    name:"Video",
    data() {
        return {
            
        }
    },
    mounted() {
        let chapterNumAlls = 0;
        data.part_list.map(e=>{
            chapterNumAlls += e.chapter_list.length
        })
        this.$store.commit('chapterNumCur', chapterNumAlls-1)
        this.$store.commit('setScaleState', false)
    },
    activated (){
        let chapterNumAlls = 0;
        data.part_list.map(e=>{
            chapterNumAlls += e.chapter_list.length
        })
        this.$store.commit('chapterNumCur', chapterNumAlls-1)
        this.$store.commit('setScaleState', false)
    },
    computed: {
        video_finished() {
            return this.$store.state.video_finished;
        },
        cur_data() {
            return this.$store.state.cur_data;
        },
        next_data() {
            return this.$store.state.next_data;
        },
        cur_chap_index(){
            return this.$store.state.currentChapterIndex;
        },
        cur_part_index(){
            return this.$store.state.currentPartIndex;
        },
    },
    methods: {
        videoOver() {
            
        },
    },
    beforeDestroy() {
        this.$store.commit('setScaleState', true)
    },
    deactivated () {
        this.$store.commit('setScaleState', true)
    },
    components:{
        aliPlayer
    }
}
</script>
<style lang="less" scoped>
.video_h5R {
  padding:.2rem 1.2rem;
  height: calc(100% - .8rem);
  box-sizing: border-box;
  .aliplayer {
    height: 100%;
    min-height: 3rem;
  }
}
</style>
